import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EmponboardingService } from '../services/emponboarding.service';

interface StaticOption {
  label: string;
  value: any;
}

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls:['./user-dialog.component.css']
})
export class UserDialogComponent implements OnInit {
  firstName = '';
  email = '';
  selectedStaticValue: any = '';
  staticOptions: StaticOption[] = [];
  staticFieldLabel = 'Company';
  staticFieldKey = 'company';
  staticLoading = false;

  constructor(
    public dialogRef: MatDialogRef<UserDialogComponent>,
    private emponboardingService: EmponboardingService
  ) {}

  ngOnInit(): void {
    this.loadStaticOptions();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private loadStaticOptions(): void {
    const umail = this.emponboardingService.umail;
    if (!umail) {
      return;
    }

    this.staticLoading = true;
    this.emponboardingService.getStaticData(umail).subscribe(
      (res: any) => {
        const source = res?.data || res || {};
        const dropdownSource = this.extractDropdownSource(source);

        if (dropdownSource) {
          this.staticFieldKey = this.normalizeFieldKey(dropdownSource.key);
          this.staticFieldLabel = this.toLabel(this.staticFieldKey);
          this.staticOptions = this.mapOptions(dropdownSource.options);
        } else {
          this.staticOptions = [];
        }

        this.staticLoading = false;
      },
      () => {
        this.staticLoading = false;
        this.staticOptions = [];
      }
    );
  }

  private extractDropdownSource(source: any): { key: string; options: any[] } | null {
    const preferredKeys = ['company_list', 'companies', 'company', 'business_list', 'businesses'];

    for (const key of preferredKeys) {
      if (Array.isArray(source?.[key]) && source[key].length) {
        return { key, options: source[key] };
      }
    }

    const firstArrayKey = Object.keys(source || {}).find((key) => Array.isArray(source[key]) && source[key].length);
    return firstArrayKey ? { key: firstArrayKey, options: source[firstArrayKey] } : null;
  }

  private mapOptions(options: any[]): StaticOption[] {
    return (options || []).map((option: any) => {
      if (typeof option === 'string' || typeof option === 'number') {
        return { label: String(option), value: option };
      }

      if (Array.isArray(option)) {
        return {
          label: String(option[1] ?? option[0] ?? ''),
          value: option[0] ?? option[1] ?? ''
        };
      }

      return {
        label: String(option.label ?? option.name ?? option.value ?? option.title ?? option.code ?? ''),
        value: option.id ?? option.value ?? option.key ?? option.code ?? option.name ?? ''
      };
    }).filter((option: StaticOption) => option.label && option.value !== '');
  }

  private normalizeFieldKey(key: string): string {
    return key.endsWith('_list') ? key.replace(/_list$/, '') : key;
  }

  private toLabel(key: string): string {
    return key
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  handleClick(): void {
    const umail = this.emponboardingService.umail;
    const fname = this.firstName;
    const email = this.email;
    const extraData = this.staticOptions.length
      ? { [this.staticFieldKey]: this.selectedStaticValue }
      : {};

    this.emponboardingService.createUser(umail, fname, email, extraData).subscribe(
      (res: any) => {
        console.log(res ? JSON.stringify(res) : '');
        alert(`User Added! ${this.firstName} ${this.email}`);
        this.dialogRef.close("Added!");
        window.location.reload();
      },
      (err: any) => {
        let errorMessage = "An error occurred.";
        if (err.error) {
          errorMessage = err.error.error || errorMessage;
        }
        alert(errorMessage);
      }
    );
  }
}